import { Deal } from "@Types/deal";
import Grid from "@Components/Grid";
import Paper from "@Components/Paper";
import { formatDate } from "@Utils/functions";
import { renderFieldData } from "@Components/FieldData/RenderFieldData";

type ApplicantProps = {
  type: "applicant" | "coApplicant";
  deal: Deal;
};

export const maskSSN = (ssn: string) => {
  const lastFourDigits = ssn?.slice(-4);
  if (lastFourDigits) {
    return `XXX-XX-${lastFourDigits}`;
  }
  return "Invalid SSN";
};

const Applicant = ({ type, deal }: ApplicantProps) => {
  const applicant = deal?.data?.[type];
  return applicant ? (
    <Paper
      title={type === "applicant" ? "Customer" : "Co-Customer"}
      style={{ boxSizing: "border-box", height: "100%" }}
    >
      <Grid xs={12}>
        {renderFieldData(
          "Name",
          `${applicant?.data.info.firstName ?? ""} ${
            applicant?.data.info.lastName ?? ""
          }`
        )}
      </Grid>
      <Grid xs={12}>
        {renderFieldData(
          "Address",
          `${applicant?.data.info.currentAddressNumber ?? ""} ${
            applicant?.data.info.currentAddress ?? ""
          }
          ${applicant?.data.info.currentCity ?? ""} ${
            applicant?.data.info.currentState ?? ""
          }`
        )}
      </Grid>
      <Grid xs={12}>
        {renderFieldData(
          "DOB",
          formatDate(`${applicant?.data.info.birthDate ?? ""}`)
        )}
      </Grid>
    </Paper>
  ) : null;
};

export default Applicant;
